import { render, staticRenderFns } from "./TheComputerAssetList.vue?vue&type=template&id=72f7d997&"
import script from "./TheComputerAssetList.vue?vue&type=script&lang=js&"
export * from "./TheComputerAssetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports